import { useState } from 'react';
import { 
    guardarLibretaDeEmpleado, 
    obtenerDocumentosPorEmpleado, 
    eliminarDocumento, 
    getDocumentoCabByEmpleadoYTipo,
    guardarDocumentosCab,
    modificarDocumentosCab,
    anulaDocumentoCab
} from '../../../services/empleado/empleadoDocumentoService';
import { formatToJava } from '../../../util/dateUtils';

const emptyLibreta = { id: null, categoria: null, numero: '', fechaIngreso: null, fechaFin: null, categoriaId: null };

// Helper de fechas
const convertirFecha = (f) => {
    if (!f) return null;
    if (Array.isArray(f)) return new Date(f[0], f[1] - 1, f[2]);
    if (typeof f === 'object' && f.year) return new Date(f.year, f.monthValue - 1, f.dayOfMonth);
    if (typeof f === 'string') return new Date(f);
    return new Date(f);
};

export const useLibreta = ({ empleadoId, toast, configMap, listas }) => {

    // 1. Estados
    const [libretas, setLibretas] = useState([]);
    const [libretaData, setLibretaData] = useState(emptyLibreta);
    const [libretaDialog, setLibretaDialog] = useState(false); // Modal Formulario
    const [libretaFile, setLibretaFile] = useState([]);

    const [loading, setLoading] = useState(false);

    const [procLibreta, setProcLibreta] = useState(false)
    
    // 2. Carga de Libretas
    const recargarLibretas = async (id) => {
        if (!id) { setLibretas([]); return; }

        try {
            const docs = await obtenerDocumentosPorEmpleado(id);

            // A. Buscar ID de configuración
            const configLibreta = listas?.tiposOtrosDocs?.find(d => d.codigo === configMap.FORM_LIBRETA);
            let ID_LIBRETA = configLibreta ? configLibreta.configuracionDetId : null;

            // B. Fallback: Buscar por descripción si no hay configuración
            if (!ID_LIBRETA && docs.length > 0) {
                const posible = docs.find(d => d.descripcion && d.descripcion.includes("Libreta"));
                if (posible) ID_LIBRETA = posible.tipoDocumentoId;
            }

            // C. Filtrar y Mapear
            if (ID_LIBRETA || docs.length > 0) {
                const misLibretas = docs.filter(d =>
                    (ID_LIBRETA && d.tipoDocumentoId === ID_LIBRETA) ||
                    (d.descripcion && d.descripcion.includes("Libreta"))
                );

                setLibretas(misLibretas.map(doc => ({
                    id: doc.id,
                    categoria: doc.categoriaId, // ID para el Dropdown
                    numero: doc.referencia,     // El backend manda el nro en 'referencia'
                    fechaIngreso: convertirFecha(doc.fechaInicio),
                    fechaFin: convertirFecha(doc.fechaFin),
                    archivoUrl: doc.url
                })));
            }
        } catch (e) {
            console.error("Error recargando libretas:", e);
        }
    };

    // 3. Acciones de Apertura
    const openNewLibreta = () => {
        setLibretaData(emptyLibreta);
        setLibretaFile(null);
        setLibretaDialog(true);
    };

    const openEditLibreta = (rowData) => {
        setLibretaData({ ...rowData });
        setLibretaFile(null); // Reset archivo al editar
        setLibretaDialog(true);
    };

    // Helper para inputs del formulario
    const onLibretaChange = (val, name) => {
        setLibretaData(prev => ({ ...prev, [name]: val }));
    };

    // 4. Guardar
    const saveLibreta = async () => {
        if (loading) return;
        if (!empleadoId) {
            toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'Guarde el empleado primero.' });
            return;
        }

        if (!libretaData.categoria || !libretaData.numero) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Categoría y Número son obligatorios.' });
            return;
        }
        
        // Validación de archivo solo para nuevos
        if (!libretaData.id && !libretaFile) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe adjuntar el documento.' });
            return;
        }

        const formatearFecha = (d) => d && d.toISOString ? d.toISOString().split('T')[0] : null;

        const payload = {
            id: libretaData.id,
            entidadId: empleadoId,
            codigoTipoDocumento: configMap.FORM_LIBRETA,
            categoriaId: libretaData.categoria, 
            referenciaDetalle: libretaData.numero, // Importante: referenciaDetalle guarda el número
            descripcion: `Libreta Militar`,
            fechaInicio: formatearFecha(libretaData.fechaIngreso),
            fechaFin: formatearFecha(libretaData.fechaFin)
        };

        try {
            setLoading(true);
            await guardarLibretaDeEmpleado(empleadoId, payload, libretaFile);
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Libreta guardada correctamente' });

            setLibretaDialog(false);
            setLibretaData(emptyLibreta);
            setLibretaFile(null);
            await recargarLibretas(empleadoId);

        } catch (error) {
            console.error(error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo guardar la libreta' });
        } finally {
            setLoading(false);
        }
    };

    // 5. Eliminar
    const deleteLibreta = async (rowData) => {
        if (!window.confirm(`¿Estás seguro de eliminar la libreta número ${rowData.numero}?`)) return;

        try {
            await eliminarDocumento(rowData.id);
            toast.current.show({ severity: 'success', summary: 'Eliminado', detail: 'Libreta eliminada.' });
            
            // Actualización optimista
            setLibretas(prev => prev.filter(item => item.id !== rowData.id));
        } catch (error) {
            console.error("Error eliminando libreta:", error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo eliminar.' });
        }
    };

    /* CODIGO NUEVO BEGIN  */
    const cargaLibretas = async (empleadoId) => {
            const CODE_TIPOREGISTRO_LIBRETA = 'NOM-0000-0015-0001';
            try {
                const data = await getDocumentoCabByEmpleadoYTipo(
                    empleadoId,
                    CODE_TIPOREGISTRO_LIBRETA
                );
                //console.log ('DATOS;', data)
                const lista = data.map((item) => ({
                    id: item.documentoCabId,
                    categoria: item.categoriaConfDet.configuracionDetId,
                    numero: item.referenciaDetalle,
                    fechaIngreso: convertirFecha(item.fechaInicio),
                    fechaFin: convertirFecha(item.fechaFin),
                    archivoUrl: ''
                }));
                setLibretas(lista);
            } catch (error) {
                console.error('Error al Obtener Licencias:', error);
            }
        };

    const guardaLibreta = async () => {
        const CODE_TIPOREGISTRO_LIBRETA = 'NOM-0000-0015-0001';
        if (loading) return;
        if (!empleadoId) {
            toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'Guarde el empleado primero.' });
            return;
        }

        if (!libretaData.categoriaId || !libretaData.numero) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Categoría y Número son obligatorios.' });
            return;
        }
        
        // Validación de archivo solo para nuevos
        if (!libretaData.id && !libretaFile) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe adjuntar el documento.' });
            return;
        }

        setProcLibreta(true)
        try {
            const objGuardar = {
                entidadId: empleadoId,
                nombreEntidad: 'EMPLEADO',
                categoriaConfDetId: libretaData.categoriaId,
                referenciaDetalle: libretaData.numero,
                descripcion: `Libreta Militar`,
                fechaInicio: formatToJava(libretaData.fechaIngreso),
                fechaFin: libretaData.fechaFin ? formatToJava(libretaData.fechaFin) : "",
                fechaEmision: '', 
                codigoTipoDocumento: CODE_TIPOREGISTRO_LIBRETA
            }
            if (libretaData.id) {
                objGuardar['documentoCabId'] = libretaData.id;
                const data = await modificarDocumentosCab(objGuardar, libretaFile);
            } else {
                //console.log ('fecha REVISAR: ', objGuardar)
                const data = await guardarDocumentosCab(objGuardar, libretaFile);
            }
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Libreta guardada correctamente' });

            setLibretaDialog(false);
            setLibretaData(emptyLibreta);
            setLibretaFile(null);
            await cargaLibretas(empleadoId);

        } catch (error) {
            console.error('Error al Guardar Licencias:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se han guardado las Licencias'
            });
        } finally {
            setProcLibreta(false)
        }
    }

    const anulaLibreta = async (rowData) => {
            if (!window.confirm(`¿Estás seguro de eliminar la licencia ${rowData.numero}?`)) return;

            try {
                const data = await anulaDocumentoCab(rowData.id);
                toast.current.show({
                    severity: 'success',
                    summary: 'Eliminado',
                    detail: 'Licencia eliminada.'
                });
    
                // Actualización optimista o recarga
                setLibretas((prev) => prev.filter((item) => item.id !== rowData.id));
            } catch (error) {
                console.error('Error eliminando licencia:', error);
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No se pudo eliminar.'
                });
            }
        };

    /* CODIGO NUEVO END */

    return {
        libretas,
        libretaData, setLibretaData,
        libretaDialog, setLibretaDialog,
        libretaFile, setLibretaFile,
        recargarLibretas,
        openNewLibreta,
        openEditLibreta,
        saveLibreta,
        deleteLibreta,
        onLibretaChange,
        setLibretas,
        loading,
        cargaLibretas,
        guardaLibreta,
        procLibreta,
        anulaLibreta
    };
};